import { Fragment,useState } from "react"
import ServicesCard from "./cards/servicesCard"
import { Box } from "@mui/material";
import ChargingStations from "./services/charging-stations/ChargingStations";
import BookAppointmentForm from "./book-appointemt-form/BookAppointmentForm";
import Breadcrumb from "../../UI/breadcrumb/breadcrumb";
import GlobalSnackBar from "UI/snackbar/GlobalSnackBar";
import Services from "./services/findServices";
import FeedbackPopup from "UI/feedback-popup/feedback-popup";


const NewServices = () => {
    const [toggleSnackbar, setToggleSnackbar] = useState({ message: '', isToggle: false, mode: '' });
    const [serviceName,setServiceName] = useState("")
    const [bookingService,setBookingService] = useState("")
    const [findCards, setFindCards] = useState<boolean>(false)
    const [openFeedbackPopup, setOpenFeedbackPopup] = useState<boolean>(false);
    const [toggleSnack, setToggleSnack] = useState({ message: "", isToggle: false, mode: "" });
    const [selectedCard, setSelectedCard] = useState<any>([])
    const [ownerId ,setOwnerId]=useState("")


    const tempArray = [
        { name: "Services " },
        { name: "Dashboard ", onClickNavigateTo: "/"},
        { name: serviceName &&"/ "},
        { name: serviceName ? ` Find ${serviceName} `:"/",color:bookingService ==='Book Appointment' && '#00BCD4',  onClickNavigateTo:bookingService ==='Book Appointment' && "/personal-services"},
        { name: bookingService && `/ ${bookingService}`},
    ];
    const servicesFeedback=(ownerIdService:any)=>{
        setOwnerId(ownerIdService)
    }

    return (
        <Fragment>
            <Box sx={{ position: 'relative' }}>
                <Breadcrumb breadCrumbData={tempArray} />
                {toggleSnackbar.isToggle && <GlobalSnackBar isOpenSnack={toggleSnackbar} 
                setIsOpenSnack={setToggleSnackbar} />}
                 {toggleSnack.isToggle && <GlobalSnackBar isOpenSnack={toggleSnack} 
                setIsOpenSnack={setToggleSnack} />}
            </Box>
            {!findCards && 
                <ServicesCard serviceName={setServiceName} setFindCards={setFindCards} />}
            {(findCards && serviceName !=='Charging Station' && bookingService !=='Book Appointment') && 
                <Services setFindCards={setFindCards} setBookingService={setBookingService} serviceName={serviceName}
                 setServiceName={setServiceName} setSelectedCard={setSelectedCard}/>}
            { serviceName ==='Charging Station' && <ChargingStations setServiceName={setServiceName}/>}
            { bookingService ==='Book Appointment' && <BookAppointmentForm setServiceName={setServiceName} 
            serviceName={serviceName} setBookingService={setBookingService} selectedCard={selectedCard} setToggleSnackbar={setToggleSnackbar} setOpenFeedbackPopup={setOpenFeedbackPopup} servicesFeedback={servicesFeedback} /> }
            {openFeedbackPopup && (
          <FeedbackPopup
            feedBack={setToggleSnack}
            open={openFeedbackPopup}
            setOpen={setOpenFeedbackPopup}
            ownerId={ownerId}
          />
        )}
        </Fragment>
    )
}

export default NewServices
